export function isNonJsonTrpcTransportError(error: unknown): boolean {
  return (
    error instanceof Error &&
    (error.message.includes('Unexpected token') ||
      error.message.includes('non-JSON response'))
  );
}
